export default "__VITE_ASSET__70UuLo6u__"